module.exports = __webpack_public_path__ + "img/ocbc.6bcf17a1.png";